import inputFieldWidget from "./inputFieldWidget.js";

/**
 * Textarea field that supports multiple lines of text.
 *
 * _Options:_
 * rows			number of rows to display
 *
 * See inputField for more options
 */
function textareaFieldWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = inputFieldWidget(spec, my);

	my.renderInputFieldOn = function (html) {
		return html.textarea(
			{
				class: spec.klass || "form-control",
				rows: spec.rows || 3,
				id: spec.id || spec.attribute,
				name: spec.name || spec.attribute,
				placeholder: spec.placeHolder,
			},
			that.getValue() || "",
		);
	};

	return that;
}

export default textareaFieldWidget;
